import AntdCheckbox from 'antd/lib/checkbox';

export type CheckboxOption = {
	label: string,
	value: string,
	disabled?: boolean,
}

export type CheckboxGroupProps = Omit<FieldProps, 'placeholder' | 'autofocus' | 'value'> & {
	options: CheckboxOption[];
	value?: string[];
}

export default function CheckboxGroup(props: CheckboxGroupProps) {
	return (
		<AntdCheckbox.Group
			{...props}
			options={props.options}
		/>
	);
}
